export default __webpack_public_path__ + "static/media/deauville11.cd06bff1.jpg";